export default "__VITE_ASSET__zc28wjX9jUVW7jV_qPTNNw__"